import { LimiteViewModel, PeriodoLimiteModel } from "./limits";

export class TransfersDataViewModel{
	type: string;
	title: string;
	description: string;
	limitViewModel: LimiteViewModel;
}

export class SelectedLimitData{
	title: string;
	description: string;
	value?: number;
	limit: PeriodoLimiteModel;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/models/select-ajust-limits.ts